import { axiosInstance } from '../../services'
import { ADD_CRM_EVENT } from '../../services/endpoints'

export enum EngagementEvents {
  ADMIN_LOGGED_IN = 'adminLoggedIn',

  INVESTOR_BLOCKED = 'blockedInvestor',
  INVESTOR_UNBLOCKED = 'unblockedInvestor',
  CLICKED_RESEND_VERIFICATION_LINK = 'clickedResendVerificationLink',
  CLICKED_EDIT_INVESTMENT_LIMIT = 'clickedEditInvestmentLimit',

  UPDATED_INVESTMENT_STATUS = 'updatedInvestmentStatus',
  UPDATED_WITHDRAWAL_STATUS = 'updatedWithdrawalStatus',
  CLICKED_VIEW_WELCOME_LETTER = 'clickedViewWelcomeLetter',
  CLICKED_VIEW_KYC_REPORT = 'clickedViewKycReport',
  CLICKED_VIEW_SWIFT_COPY = 'clickedViewSwiftCopy',
  CLICKED_DOWNLOAD_CLIENT_AGREEMENT = 'clickedDownloadClientAgreement',
  CLICKED_VIEW_ORDER = 'clickedViewOrder',
  CLICKED_VIEW_INVESTMENT = 'clickedViewInvestment',
  CLICKED_VIEW_WITHDRAWAL = 'clickedViewWithdrawal',
  CLICKED_MANAGE_PROFILE = 'clickedManageProfile',
  CLICKED_INVESTOR_INVESTMENTS = 'clickedInvestorInvestments',
  CLICKED_INVESTOR_WITHDRAWALS = 'clickedInvestorWithdrawals',
  SAVED_OPPORTUNITY = 'savedOpportunity',
  CLICKED_EDIT_OPPORTUNITY = 'clickedEditOpportunity',
  CLICKED_VIEW_INVESTMENTS_FOR_OPPORTUNITY = 'clickedViewInvestmentsForOpportunity',
  CLICKED_VIEW_WITHDRAWALS_FOR_OPPORTUNITY = 'clickedViewWithdrawalsForOpportunity',
  VISITED_OPPORTUNITIES_PAGE = 'visitedOpportunitiesPage',
  VISITED_ADD_OPPORTUNITY_PAGE = 'visitedAddOpportunityPage',
  VISITED_ORDERS_PAGE = 'visitedOrdersPage',
  VISITED_INVESTORS_PAGE = 'visitedInvestorsPage',
  VISITED_INQUIRIES_PAGE = 'visitedInquiriesPage',
  VISITED_BUSINESS_INQUIRIES_PAGE = 'visitedBusinessInquiriesPage',
  VISITED_UNIT_PRICES_PAGE = 'visitedUnitPricesPage',
  VISITED_INTEREST_PAYOUTS_PAGE = 'visitedInterestPayoutsPage',
}

export async function logCrmEvent(eventName: EngagementEvents, eventData?: object): Promise<any> {
  try {
    return await axiosInstance.post(ADD_CRM_EVENT, {
      eventName: eventName,
      eventData: JSON.stringify(eventData),
    })
  } catch (error: any) {
    return error.response
  }
}
